// export interface ILogoAnimationConfig {
//     animationConfig: Types.Animations.Animation;
//     logoAnimationFileName: string;
//     logoAnimationPath: string;
//     logoScale: number;
//     textureConfig: Types.Loader.FileTypes.ImageFrameConfig;
// }

export const STARTUP_LOGO_CONFIG = {
    logoAnimationPath: 'configuration/games/_shared/preloader/',
    logoAnimationFileName: 'preloaderAnimation.webp',
    logoScale: 1,
    textureConfig: {
        frameWidth: 410,
        frameHeight: 74,
        startFrame: 1,
        endFrame: 40
    },
    animationConfig: {
        key: 'logoAnimationKey',
        frames: 'logoAnimationKey',
        frameRate: 40
    }
};
